<div ngModelGroup="comboTributos" fxFlex="40%" fxLayoutGap="20px" fxFlexOffset="20px">
    <combo-pesquisavel #comboTributos 
                        nome="tributos" 
                        [itens]="tributos" 
                        itemDescricao="codigo"
                        [obrigatorio]="true"
                        itemId="id"
                        placeholder="Tributo"
                        label="Tributo"
                        [(valor)]="tributoMovimentacao.tributo"
                        (valorChange)="onValorTributoChange($event); validarCadastroTributos();">
    </combo-pesquisavel>
</div>
<mat-form-field fxFlex="20%" fxFlexOffset="20px" *ngIf="showInputValor">
    <input [(ngModel)]="tributoMovimentacao.valor" 
           currencyMask 
           name="valor_{{pinValor}}"           
           matInput            
           maxlength="13"
           [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
    <span matPrefix>R$&nbsp;</span>
</mat-form-field> 

<mat-form-field fxFlex="40%" fxFlexOffset="20px">
    <input [(ngModel)]="tributoMovimentacao.tributo.recebedor" 
           name="recebedor_{{pinRecebedor}}"   
           disabled
           placeholder="Destinatário"        
           matInput />
</mat-form-field>

<div fxFlex="10%" style="margin-top: 18px;margin-left: 26px;" >
    <button mat-icon-button 
            *ngIf="perfilAcesso.deleta" 
            (click)="deletar()"
            style="padding: 0px;">
        <mat-icon>delete_forever</mat-icon>
    </button>                                
</div>

